import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import ImpersonationBanner from "../ImpersonationBanner/ImpersonationBanner";
import { useAuth } from "../../context/AuthContext";
import "./Layout.css";

const Layout = () => {
  const { user } = useAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if sidebar collapsed state is saved in localStorage
  useEffect(() => {
    const savedState = localStorage.getItem("sidebarCollapsed");
    if (savedState) {
      setSidebarCollapsed(JSON.parse(savedState));
    }

    // Add event listener to check for window resize
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth <= 768) {
        setSidebarCollapsed(true);
      }
    };

    // Listen for the storage event from the Header component
    const handleStorageChange = () => {
      const currentState = localStorage.getItem("sidebarCollapsed");
      if (currentState) {
        setSidebarCollapsed(JSON.parse(currentState));
      }
    };

    // Initial call
    handleResize();

    // Set up event listeners
    window.addEventListener("resize", handleResize);
    window.addEventListener("storage", handleStorageChange);

    // Sidebar broadcasts `sidebar:collapse-change` (see Sidebar.js) — mirror
    // it here so the layout margin tracks the sidebar width in the same tab.
    const handleCollapseBroadcast = (e) => setSidebarCollapsed(e.detail.isCollapsed);
    window.addEventListener("sidebar:collapse-change", handleCollapseBroadcast);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("sidebar:collapse-change", handleCollapseBroadcast);
    };
  }, []);

  return (
    <div className={`layout ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}>
      <Sidebar />
      <div className="layout-content">
        <ImpersonationBanner />
        <Header />
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
